import { gql } from 'src/__generated__';

const CREATE_REPORT_TEMPLATE = gql(`#graphql
mutation CreateReportTemplate($input: CreateReportTemplateInput!) {
  createReportTemplate(input: $input)
}`);

export default CREATE_REPORT_TEMPLATE
